/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const DocumentType = {
    Other: 0,
    AsbestosManagementPlan: 1,
    AsbestosRegister: 2,
    AsbestosSurveyReport: 3,
    EmergencyResponsePackFireBrigadeCorrespondence: 4,
    EmergencyResponsePackFireBrigadeInformationPack: 5,
    EmergencyResponsePackFireFightingFacilitiesLocationPlan: 6,
    EmergencyResponsePackFireIndicatorPanelMap: 7,
    EmergencyResponsePackFireLogBook: 8,
    EvacuationEvacuationStrategy: 9,
    EvacuationFireDrillRecords: 10,
    EvacuationEvacuationPlans: 11,
    EvacuationWardenTrainingRecords: 12,
    FireSafetyComplianceAnnualFireSafetyStatement: 13,
    FireSafetyComplianceCladdingAuditReport: 14,
    FireSafetyComplianceESMRegister: 15,
    FireSafetyComplianceFireEngineeringReport: 16,
    FireSafetyComplianceFireSafetySchedule: 17,
    FireSafetyComplianceSafetyCaseReport: 18,
    FireStrategyCauseEffectMatrix: 19,
    FireStrategyConstructionFireSafetyPlan: 20,
    FireStrategyEgressAssessment: 21,
    FireStrategyFRLSchedule: 22,
    HealthSafetyFilesWHSManagementPlan: 23,
    IncidentRiskReportingIncidentRegister: 24,
    IncidentRiskReportingIncidentReport: 25,
    PestControlPestControlReport: 26,
    RiskAssessmentsCombustibleCladding: 27,
    RiskAssessmentsConfinedSpaces: 28,
    RiskAssessmentsFireSafety: 29,
    RiskAssessmentsFlood: 30,
    RiskAssessmentsGeneralWHS: 31,
    RiskAssessmentsHazardousSubstances: 32,
    RiskAssessmentsLegionella: 33,
    RiskAssessmentsNoise: 34,
    RiskAssessmentsPlantEquipment: 35,
    RiskAssessmentsRoofAccessWorkingAtHeights: 36,
    RiskAssessmentsSafeDesign: 37,
    RiskAssessmentsSafeWorkMethodStatement: 38,
    SpecificationsHealthSafetyAndComplianceCladding: 39,
    SpecificationsHealthSafetyAndComplianceFireDetectionAlarmSystems: 40,
    SpecificationsHealthSafetyAndComplianceFireDoors: 41,
    SpecificationsHealthSafetyAndComplianceFireExtinguishers: 42,
    SpecificationsHealthSafetyAndComplianceFireHydrantHoseReelSystems: 43,
    SpecificationsHealthSafetyAndComplianceInsulationFireCavityBarriers: 44,
    TrainingCompetenceHealthSafetyAndComplianceFirstAidTrainingRecords: 45,
    TrainingCompetenceHealthSafetyAndComplianceSiteInductionRegister: 46,
    BuildingApprovalsBuildingPermitApplication: 47,
    BuildingApprovalsBuildingSurveyorInspectionReport: 48,
    BuildingApprovalsCertificateOfFinalInspection: 49,
    BuildingApprovalsOccupancyPermit: 50,
    BuildingApprovalsWorkSafeNotification: 51,
    ContractsConstructionAndDevelopmentBankGuaranteeSecurity: 52,
    ContractsConstructionAndDevelopmentBuildingContract: 53,
    ContractsConstructionAndDevelopmentContractWorksInsurance: 54,
    ContractsConstructionAndDevelopmentContractorPrequalification: 55,
    ContractsConstructionAndDevelopmentExtensionOfTime: 56,
    ContractsConstructionAndDevelopmentNotices: 57,
    ContractsConstructionAndDevelopmentPrincipalsRequirements: 58,
    ContractsConstructionAndDevelopmentVariations: 59,
    InspectionsReportsSurveysConstructionAndDevelopmentAirPermeabilityTestReport: 60,
    InspectionsReportsSurveysConstructionAndDevelopmentDialBeforeYouDig: 61,
    InspectionsReportsSurveysConstructionAndDevelopmentFireBarrierPenetrationRecord: 62,
    InspectionsReportsSurveysConstructionAndDevelopmentFireCompartmentationSurvey: 63,
    InspectionsReportsSurveysConstructionAndDevelopmentMeasurementAreaSurvey: 64,
    InspectionsReportsSurveysConstructionAndDevelopmentPhotoDocumentation: 65,
    InspectionsReportsSurveysConstructionAndDevelopmentSiteInspectionReport: 66,
    InspectionsReportsSurveysConstructionAndDevelopmentStructuralInspectionReport: 67,
    PlanningCouncilCorrespondence: 68,
    PlanningDevelopmentApplication: 69,
    PlanningDevelopmentConsent: 70,
    PlanningHeritageImpactStatement: 71,
    PlanningPlanningAmendment: 72,
    PlanningPlanningApproval: 73,
    PlanningPlanningRefusalNotice: 74,
    PlanningStatementOfEnvironmentalEffects: 75,
    PlanningVoluntaryPlanningAgreement: 76,
    PlanningWorksInPublicDomainAgreement: 77,
    PracticalCompletionDefectsAsBuiltInformationSchedule: 78,
    PracticalCompletionDefectsCertificateOfMakingGood: 79,
    PracticalCompletionDefectsDevelopersCompletionStatement: 80,
    PracticalCompletionDefectsOutstandingDefectsList: 81,
    PracticalCompletionDefectsPracticalCompletionCertificate: 82,
    ProductMaterialInformationCladdingFacadeCertification: 83,
    ProductMaterialInformationDoorsWindowsCertification: 84,
    ProductMaterialInformationFireStoppingCertification: 85,
    ProductMaterialInformationFireStoppingInstallationRecord: 86,
    ProductMaterialInformationFinishesSchedules: 87,
    ProductMaterialInformationPassiveFireProtectionCertification: 88,
    ProductMaterialInformationProductInformation: 89,
    ProductMaterialInformationThirdPartyProductCertification: 90,
    ProjectInformationChangeControlLog: 91,
    ProjectInformationProjectFinancials: 92,
    ProjectInformationProjectProgramme: 93,
    ProjectInformationRemedialWorksScope: 94,
    ProjectInformationSiteMeetingMinutes: 95,
    ProjectInformationTenderSubmissions: 96,
    ProjectInformationTrafficManagementPlan: 97,
    ProjectInformationWHSRiskRegister: 98,
    SpecificationsConstructionAndDevelopmentCoatings: 99,
    SpecificationsConstructionAndDevelopmentElectrical: 100,
    SpecificationsConstructionAndDevelopmentGeneralBuilding: 101,
    SpecificationsConstructionAndDevelopmentInteriorDesignFitout: 102,
    SpecificationsConstructionAndDevelopmentNCCFireSafetyCompliance: 103,
    SpecificationsConstructionAndDevelopmentStructuralDesignCalculations: 104,
    SpecificationsConstructionAndDevelopmentWindLoading: 105,
    WarrantiesBuildingWarranty: 106,
    WarrantiesProductWarranties: 107,
    WarrantiesProfessionalIndemnity: 108,
    CommunicationSystemsStructuredCablingCertification: 109,
    ContractsBuildingOperationsAndFacilitiesFacilitiesManagementContract: 110,
    ContractsBuildingOperationsAndFacilitiesRolesResponsibilitiesMatrix: 111,
    ContractsBuildingOperationsAndFacilitiesServiceContractsSchedule: 112,
    ElectricalSystemsCertification: 113,
    ElectricalSystemsLoadCapacityMaximumDemand: 114,
    ElectricalSystemsMeterReadings: 115,
    ElectricalSystemsProductInformation: 116,
    ElectricalSystemsSupplyAgreement: 117,
    ElectricalSystemsSwitchboardDirectory: 118,
    ElectricalSystemsTestTagRegister: 119,
    ElectricalSystemsGeneratorRecords: 120,
    FinancialPPMCapExSchedule: 121,
    FireDoorsDoorSchedule: 122,
    FireDoorsInspectionRecord: 123,
    FireDoorsSurveyGapAnalysis: 124,
    GasSystemsCertification: 125,
    GasSystemsComplianceCertificate: 126,
    GasSystemsGasRoutingPlan: 127,
    GasSystemsMaintenanceRecords: 128,
    GasSystemsMeterReadings: 129,
    GasSystemsSupplyAgreement: 130,
    GreaseTrapMaintenanceLog: 131,
    EmbeddedNetworksCertification: 132,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesAccessDDAAudit: 133,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesBMUTestReport: 134,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesElectricalSurvey: 135,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesESMInspection: 136,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesFGasRefrigerantRegister: 137,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesFacadeCladdingInspection: 138,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesLuxLevelChecks: 139,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesPeriodicInspectionReport: 140,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesRoofSafetyInspection: 141,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesTenancyInspectionReport: 142,
    LifeSafetySystemsCertification: 143,
    LifeSafetySystemsEmergencyExitLightingTestRecords: 144,
    LifeSafetySystemsFireAlarmTestRecords: 145,
    LifeSafetySystemsFireAlarmZonePlan: 146,
    LifeSafetySystemsMaintenanceRecords: 147,
    LifeSafetySystemsProductInformation: 148,
    LifeSafetySystemsSprinklerServiceReport: 149,
    LiftsElevatorsCertification: 150,
    LiftsElevatorsMaintenanceRecords: 151,
    OMManual: 152,
    OtherBuildingAssetsMaintenanceRecords: 153,
    PermitsConfinedSpacesEntryPermit: 154,
    PermitsElectricalWorkPermit: 155,
    PermitsHotWorksPermit: 156,
    PermitsWorkingAtHeightsPermit: 157,
    PoliciesProceduresStrategiesBuildingMaintenanceProcedures: 158,
    PoliciesProceduresStrategiesBuildingOperatingProcedures: 159,
    PoliciesProceduresStrategiesHardServicesMaintenancePlan: 160,
    PoliciesProceduresStrategiesSecurityPolicy: 161,
    PoliciesProceduresStrategiesServicesStrategy: 162,
    PressureSystemsPressureInspectionReport: 163,
    SecuritySystemsAutomaticGateSafetyInspection: 164,
    SecuritySystemsCertification: 165,
    SecuritySystemsKeyAccessFobSchedule: 166,
    SecuritySystemsProductInformation: 167,
    StaffingStaffEmploymentRecords: 168,
    SuppliersInformationSupplierContactInformation: 169,
    TrainingCompetenceBuildingOperationsAndFacilitiesBuildingSystemsTrainingRecords: 170,
    TrainingCompetenceBuildingOperationsAndFacilitiesManualHandlingTrainingRecords: 171,
    UtilitiesMeterSchedule: 172,
    UtilitiesUtilityBillsTariffs: 173,
    UtilitiesUtilitySupplyContracts: 174,
    UtilitiesWaterSupplyAgreements: 175,
    VentilationSystemsCertification: 176,
    VentilationSystemsHVACReport: 177,
    VentilationSystemsMaintenanceRecords: 178,
    VentilationSystemsSystemDesign: 179,
    WaterSystemsCertification: 180,
    WaterSystemsLegionellaWaterQualityLogbook: 181,
    WaterSystemsMeterReadings: 182,
    WaterSystemsProductInformation: 183,
    WaterSystemsTankInspectionCleaningRecords: 184,
    ArchitecturalFloorPlans: 185,
    ArchitecturalElevations: 186,
    ArchitecturalSections: 187,
    ArchitecturalReflectedCeilingPlans: 188,
    ArchitecturalRoofPlans: 189,
    ArchitecturalInternalFinishesPlans: 190,
    ArchitecturalDemolitionPlans: 191,
    ArchitecturalAsBuiltDrawings: 192,
    CivilStructuralSitePlans: 193,
    CivilStructuralStructuralDrawings: 194,
    CivilStructuralFoundationPlans: 195,
    CivilStructuralStormwaterDrainagePlans: 196,
    CivilStructuralEarthworksGradingPlans: 197,
    CivilStructuralRetainingWallDrawings: 198,
    CivilStructuralAsBuiltDrawings: 199,
    MechanicalHVACLayoutPlans: 200,
    MechanicalMechanicalSchematicDrawings: 201,
    MechanicalPlantRoomDrawings: 202,
    MechanicalDuctworkDrawings: 203,
    MechanicalAsBuiltDrawings: 204,
    ElectricalElectricalLayoutPlans: 205,
    ElectricalSwitchboardDistributionDrawings: 206,
    ElectricalLightingPlans: 207,
    ElectricalEmergencyLightingPlans: 208,
    ElectricalAsBuiltDrawings: 209,
    FireLifeSafetySprinklerLayoutPlans: 210,
    FireLifeSafetyFireHydrantHoseReelPlans: 211,
    FireLifeSafetyFireDetectionAlarmLayout: 212,
    FireLifeSafetySmokeControlDrawings: 213,
    FireLifeSafetyAsBuiltDrawings: 214,
    HydraulicHydraulicLayoutPlans: 215,
    HydraulicHotColdWaterServices: 216,
    HydraulicDrainageSewerPlans: 217,
    HydraulicGasServicesPlans: 218,
    HydraulicAsBuiltDrawings: 219,
    LandscapeLandscapePlans: 220,
    LandscapeIrrigationPlans: 221,
    LandscapeAsBuiltDrawings: 222,
    FacadeCladdingFacadeDrawings: 223,
    FacadeCladdingCladdingDetails: 224,
    FacadeCladdingWindowGlazingDrawings: 225,
    FacadeCladdingAsBuiltDrawings: 226,
    ComplianceCertificatesNABERSRatingCertificate: 227,
    ComplianceCertificatesNatHERSCertificate: 228,
    ComplianceCertificatesNCCSectionJReport: 229,
    GroundGeotechnicalGeotechnicalInvestigationReport: 230,
    GroundGeotechnicalRemediationMethodStatement: 231,
    GroundGeotechnicalRemediationValidationReport: 232,
    InspectionsReportsSurveysEnvironmentalAndSiteAcousticAssessment: 233,
    InspectionsReportsSurveysEnvironmentalAndSiteAirQualityAssessment: 234,
    InspectionsReportsSurveysEnvironmentalAndSiteArboristReport: 235,
    InspectionsReportsSurveysEnvironmentalAndSiteBASIXCertificate: 236,
    InspectionsReportsSurveysEnvironmentalAndSiteEnvironmentalSiteAssessment: 237,
    InspectionsReportsSurveysEnvironmentalAndSiteFloraFaunaAssessment: 238,
    InspectionsReportsSurveysEnvironmentalAndSiteHeritageImpactStatement: 239,
    InspectionsReportsSurveysEnvironmentalAndSiteNetZeroCarbonAssessment: 240,
    InspectionsReportsSurveysEnvironmentalAndSiteOvershadowingAnalysis: 241,
    LicencesNoticesEPALicence: 242,
    LicencesNoticesStormwaterDischargeLicence: 243,
    WasteWasteManagementPlan: 244,
    WasteWasteManagementStrategy: 245,
    WasteWasteTransferDocumentation: 246,
    EasementsRightOfWayEasementsRightOfCarriageway: 247,
    HeadLease: 248,
    LicencesRoomingHouseRegistration: 249,
    MarketingInformationMemorandum: 250,
    PartyWallPartyWallBoundaryDisputes: 251,
    RentOutgoingsArrearsSchedule: 252,
    RentOutgoingsBudget: 253,
    RentOutgoingsExpenditureAccounts: 254,
    RentOutgoingsNotices: 255,
    RentOutgoingsOutgoingsSchedule: 256,
    RentOutgoingsPaymentHistory: 257,
    RentOutgoingsRentalAnalysis: 258,
    RentOutgoingsSinkingFund: 259,
    ResidentTenantEngagementTenantCommunication: 260,
    ResidentTenantEngagementTenantCorrespondence: 261,
    ResidentTenantEngagementTenantHandbook: 262,
    TenanciesUnitsAddressLotSchedule: 263,
    TenanciesUnitsLeaseAgreements: 264,
    TenanciesUnitsNetLettableAreaSchedule: 265,
    TenanciesUnitsScheduleOfCondition: 266,
    TenanciesUnitsTenancySchedule: 267,
    TitleCaveatsConsents: 268,
    TitleCertificateOfTitle: 269,
    TitlePlanOfSubdivision: 270,
    TitleTitleSearch: 271,
    TitleTransferOfLand: 272,
    TransactionsContractOfSale: 273,
    TransactionsDueDiligence: 274,
    TransactionsLitigationDisputes: 275,
    InsuranceClaimsDisputesClaims: 276,
    InsuranceClaimsDisputesDisputes: 277,
    InsurancePoliciesCertificatesBuilding: 278,
    InsurancePoliciesCertificatesContents: 279,
    InsurancePoliciesCertificatesProfessionalIndemnity: 280,
    InsurancePoliciesCertificatesPublicLiability: 281,
    InsurancePoliciesCertificatesStrata: 282,
    InsurancePoliciesCertificatesTerrorismCover: 283,
    InsurancePoliciesCertificatesWorkersCompensation: 284,
    TaxABNEntityRegistration: 285,
    TaxBASGSTRegistration: 286,
    TaxDepreciationSchedule: 287,
    TaxCouncilRates: 288,
    TaxLandTax: 289,
    TaxStampDuty: 290,
    ValuationsValuationReport: 291,
    AsbestosOther: 292,
    EmergencyResponsePackOther: 293,
    EvacuationOther: 294,
    FireSafetyComplianceOther: 295,
    FireStrategyOther: 296,
    HealthSafetyFilesOther: 297,
    IncidentRiskReportingOther: 298,
    PestControlOther: 299,
    RiskAssessmentsOther: 300,
    SpecificationsHealthSafetyAndComplianceOther: 301,
    TrainingCompetenceHealthSafetyAndComplianceOther: 302,
    BuildingApprovalsOther: 303,
    ContractsConstructionAndDevelopmentOther: 304,
    InspectionsReportsSurveysConstructionAndDevelopmentOther: 305,
    PlanningOther: 306,
    PracticalCompletionDefectsOther: 307,
    ProductMaterialInformationOther: 308,
    ProjectInformationOther: 309,
    SpecificationsConstructionAndDevelopmentOther: 310,
    WarrantiesOther: 311,
    CommunicationSystemsOther: 312,
    ContractsBuildingOperationsAndFacilitiesOther: 313,
    ElectricalSystemsOther: 314,
    FinancialOther: 315,
    FireDoorsOther: 316,
    GasSystemsOther: 317,
    GreaseTrapOther: 318,
    EmbeddedNetworksOther: 319,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesOther: 320,
    LifeSafetySystemsOther: 321,
    LiftsElevatorsOther: 322,
    OMManualOther: 323,
    OtherBuildingAssetsOther: 324,
    PermitsOther: 325,
    PoliciesProceduresStrategiesOther: 326,
    PressureSystemsOther: 327,
    SecuritySystemsOther: 328,
    StaffingOther: 329,
    SuppliersInformationOther: 330,
    TrainingCompetenceBuildingOperationsAndFacilitiesOther: 331,
    UtilitiesOther: 332,
    VentilationSystemsOther: 333,
    WaterSystemsOther: 334,
    ArchitecturalOther: 335,
    CivilStructuralOther: 336,
    MechanicalOther: 337,
    ElectricalOther: 338,
    FireLifeSafetyOther: 339,
    HydraulicOther: 340,
    LandscapeOther: 341,
    FacadeCladdingOther: 342,
    ComplianceCertificatesOther: 343,
    GroundGeotechnicalOther: 344,
    InspectionsReportsSurveysEnvironmentalAndSiteOther: 345,
    LicencesNoticesOther: 346,
    WasteOther: 347,
    EasementsRightOfWayOther: 348,
    HeadLeaseOther: 349,
    LicencesOther: 350,
    MarketingOther: 351,
    PartyWallOther: 352,
    RentOutgoingsOther: 353,
    ResidentTenantEngagementOther: 354,
    TenanciesUnitsOther: 355,
    TitleOther: 356,
    TransactionsOther: 357,
    InsuranceClaimsDisputesOther: 358,
    InsurancePoliciesCertificatesOther: 359,
    TaxOther: 360,
    ValuationsOther: 361,
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesServiceReport: 362,
} as const;
